import React, { useCallback } from 'react';

import { DeleteIcon } from '@sharedCR/coreDesignSystem/icons';
import ButtonWithTooltip from 'app/shared/components/common/ButtonWithTooltip';
import { CheckboxCDS } from 'app/shared/componentsRestyled/coreDesignSystem/form';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { FieldTypesEnum } from 'constants/loanActionEditor';
import { deleteByIndex, setIn } from 'utils/data';

import { loanManagementTestIds } from '../loanManagement.testIds';

import useFormContext from './hooks/useFormContext';
import { DynamicValueInput } from './LoanActionItems';
import { groupFieldsFunction } from './LoanActionsGroup.utils';

const LoanActionVariableFieldRow = ({
  index,
  rootPath,
  options,
  isDisabled = false,
  isEditAllowed,
  isSingleItem,
}) => {
  const { form, setInForm, handleChange, setValidationErrors } = useFormContext();

  const fieldPath = `${rootPath}[${index}]`;
  const fields = _.get(form, rootPath);

  const onDeleteRow = useCallback(() => {
    setInForm(rootPath, deleteByIndex(fields, index));
    setValidationErrors(errors =>
      setIn(errors, rootPath, deleteByIndex(_.get(errors, rootPath, []), index)),
    );
  }, [index, fields, rootPath, setInForm, setValidationErrors]);

  return (
    <div className="flex items-center" key={fieldPath}>
      <DynamicValueInput
        required
        className="grow w-1/2 mr-5"
        disabled={isDisabled || !isEditAllowed}
        label="Name"
        name={`${fieldPath}.name`}
        type={FieldTypesEnum.STRING}
      />
      <DynamicValueInput
        required
        className="grow w-1/2 ml-5"
        disabled={isDisabled || !isEditAllowed}
        groupBy={groupFieldsFunction}
        label="Field"
        name={`${fieldPath}.field`}
        options={options}
        type={FieldTypesEnum.SELECT}
      />
      <CheckboxCDS
        containerClassName="ml-5 mr-5"
        data-testid={loanManagementTestIds.LOAN_MANAGEMENT_FORM_IS_REQUIRED_CHECKBOX}
        disabled={isDisabled || !isEditAllowed}
        label="Required"
        name={`${fieldPath}.isRequired`}
        value={_.get(form, `${fieldPath}.isRequired`)}
        onChange={handleChange}
      />
      {isEditAllowed && !isSingleItem && (
        <ButtonWithTooltip
          data-testid={loanManagementTestIds.getDeleteRowButtonId(fieldPath)}
          disabled={isDisabled}
          icon={DeleteIcon}
          size="medium"
          spanContainerClassName="flex items-center ml-32"
          title="Delete row"
          onClick={onDeleteRow}
        />
      )}
    </div>
  );
};

LoanActionVariableFieldRow.propTypes = {
  index: PropTypes.number.isRequired,
  rootPath: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  isSingleItem: PropTypes.bool.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
};

export default React.memo(LoanActionVariableFieldRow);
